module.exports = __webpack_public_path__ + "static/media/replace-driver-blue.570a33de.svg";